/**
 * Created by BETALOS on 23/06/2016.
 */
(function () {
    'use strict';

    class HtmlBlockController {
        constructor(blockService, $element, $compile, $scope) {
            this.$scope = $scope;
            this.$element = $element;
            this.$compile = $compile;
            this.blockService = blockService;

            this.key = null;
            this.patient = null;

            this.options = this.options || {};
        }

        static get $inject() {
            return ["blockService", "$element", "$compile", "$scope"];
        }

        $onInit() {
            const version = _.get(this.model, 'version', null);

            this.options = this.options || {};
            this.readOnly = _.isUndefined(this.readOnly) ? false : this.readOnly();
            this.hasHeader = _.isUndefined(this.hasHeader) ? true : this.hasHeader();
            this.ngModelController = this.ngModelController ? this.ngModelController : null;

            if (this.hasHeader) this.$element.addClass("flex-noshrink layout-column");

            this.editorOpts = {
                "auto_compile": true,
                "no_config_key": true,
                "has_misc_menu": true,
                "patient": this.patient,
                "has_patient_menu": true,
                "has_physician_menu": true,
                "has_measurement_menu": true,
            };

            this.blockService.get(this.key, version)
                .then(data => this.success(data));
        }

        success(data) {
            this.model = _.isUndefined(this.model) ? {} : this.model;

            this.title = data.title;
            this.secondTitle = data.second_title;
            this.hasSecondTitle = data.has_second_title;
            this.model.version = data.id;


            this.handleTemplate(data);

            if (this.html_fields && this.html_fields.length === 1 && this.html_fields[0].type === "text-editor" && _.get(this.html_fields, "0.meta_data.fill_layout", false)) {
                this.$element.addClass("layout-fill");
                this.$element.parent("mn-consultation-body").addClass("layout-fill");
            }
        }

        #handleTemplateType(template) {
            switch (template.type) {
                case "html_block":
                    this.html_fields = template.html_fields;
                    return "./html-block.tpl.html";
                case "survey_block":
                    this.meanings = template.meanings;
                    this.questions = template.questions;
                    return "./survey-block.tpl.html";
                case "form_block":
                    this.formTemplate = template.template;
                    if (!!this.options && !!this.formTemplate) {
                        this.title = _.chain(this.formTemplate.blocks)
                            .find(["name", this.options])
                            .get("label")
                            .value() || template.title;
                    }
                    return "./form-block.tpl.html";
            }
        }

        handleTemplate(templateType) {
            const tpl = require(`${this.#handleTemplateType(templateType)}`);

            let childScope = this.$scope.$new();
            let compiledDirective = this.$compile(tpl);
            let directiveElement = compiledDirective(childScope);

            this.$element.html(directiveElement);
        }

        autoSaveCall() {
            let viewValue = _.cloneDeep(this.model);

            this.ngModelController.$setViewValue(viewValue, 'change');
            this.ngModelController.$commitViewValue();
        }
    }

    module.exports = {
        template: '',
        bindings: {
            hasHeader: "&?",
            model: "=ngModel",
            key: "@mnBlockKey",
            options: "<options",
            patient: "<patient",
            title: "=?itemTitle",
            readOnly: "&?mnReadOnly",
            postSaveSubject: "<?postSaveSubject",
        },
        controllerAs: "vm",
        controller: HtmlBlockController,
        require: {ngModelController: "ngModel"},
    };

})();
